import { Navigate, useParams } from "@tanstack/react-router";
import React from "react";
import { userProfile } from "app/router";
import avatar from "../../assets/img/avatar.png";
import { Spinner } from "components/elements";
import { ActivitiesSection } from "components/form/userProfile/ActivitiesToggle";
import { ProfileForm } from "components/form/userProfile/ProfileForm";
import { ProfilePictureUpload } from "components/form/userProfile/ProfilePictureUpload";
import { useCurrentUser } from "hooks/useCurrentUser";
import { usePublicUser } from "hooks/usePublicUser";
import { SocialProfile } from "@compass/shared/types";

export const EditProfile = () => {
    const id = parseInt(useParams({ from: userProfile.id }).id);
    const _isCurrentUser = useCurrentUser()?.id === id;
    const { user, isInitialLoading } = usePublicUser(id);

    if (isInitialLoading) {
        return (
            <span className="absolute inset-0 flex items-center justify-center">
                <Spinner className="h-10 w-10 text-slate-500" />
            </span>
        );
    }

    if (!_isCurrentUser) {
        return <Navigate to="/profile/$id" params={{ id: `${id}` }} />;
    }

    return (
        <div className="mt-6">
            <div className="font-sans text-[28px] font-semibold text-[#424242]">My Profile</div>
            {user && (
                <div className="mt-4 grid grid-cols-3 gap-6">
                    <ProfilePictureUpload
                        name={user.name}
                        email={user.email}
                        avatar={user.avatarUrl || avatar}
                    />
                    <ProfileForm />
                    <ActivitiesSection user={user as SocialProfile} />
                </div>
            )}
        </div>
    );
};
